import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class EventManagerService {

  private _topicRegistry: any = {}

  public createTopic(topicName: string) {
    let _topicSubject = new Subject<any>()
    this._topicRegistry[topicName] = _topicSubject
  }

  public getTopic(topicName) {
    if (!this._topicRegistry[topicName]) {
      console.log('Creating a new topic: ' + topicName)
      this.createTopic(topicName)
    }
    return this._topicRegistry[topicName].asObservable()
  }

  public publishToTopic(topicName: string, value: any) {
    if (!this._topicRegistry[topicName]) {
      console.log('Creating a new topic: ' + topicName)
      this.createTopic(topicName)
    }
    console.log('Event Manager Service. Publish to Topic: ' + topicName)
    this._topicRegistry[topicName].next(value)
  }
}
